import React, { useState, useEffect } from "react";

import DeleteModal from "../../../../components/modelpopup/deletePopup";
import { Link } from "react-router-dom";
import AiFileAnalysisSearchBar from "../../../../components/MassAiSearchBar/SearchBar";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import OpenVatCalculator from "../CreateInvoice";
import FilesAi from "../AiFiles";
import BookBotSearchBar from "../../../../components/MassAiSearchBar/BookBotSearchBar";

export default function BookBotDashboard() {
  const [SIGNATURE, setSIGNATURE] = useState("");
  const [ORIGINAL, setORIGINAL] = useState("");
  const [filesvalues, setFilesValues] = useState([]);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [triggerUpload, setTriggerUpload] = useState(false);
  const [resetSearch, setResetSearch] = useState(false);
  const { fileSize, lastModified } = formatFileInfo(uploadedFile || "");
  const [fileValue, setFileValue] = useState("");
  const handleFileUpload = (file) => {
    // console.log("File received in parent:", file);
    setUploadedFile(file);
  };
  const triggerChildFileUpload = () => {
    setTriggerUpload(true);
    setTimeout(() => setTriggerUpload(false), 100); // Reset after trigger
  };
  function formatFileInfo(file) {
    const sizeInKB = file.size / 1024;
    const readableSize =
      sizeInKB < 1024
        ? `${sizeInKB.toFixed(2)} KB`
        : `${(sizeInKB / 1024).toFixed(2)} MB`;

    const date = new Date(file.lastModified);
    const options = {
      day: "2-digit",
      month: "short",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };
    const readableDate = date.toLocaleString("en-US", options); // Or use 'ar-EG', 'he-IL' etc. for localization

    return {
      fileSize: readableSize,
      lastModified: readableDate,
    };
  }

  return (
    <div className="main-wrapper">
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <Breadcrumbs
            maintitle="Fintrack BookBot"
            title="الرئيسية"
            subtitle="book-bot"
          />

          <div className="row">
            <div className="mb-4 pb-4 col-md-10 justify-content-center  ">
              <BookBotSearchBar
                onFileUpload={handleFileUpload}
                triggerUpload={triggerUpload}
                reset={resetSearch}
                fileTypeObject={fileValue}
              />
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <ul className="nav nav-tabs nav-tabs-solid nav-justified bookbot-tabs">
                <li className="nav-item">
                  <Link
                    className="nav-link active"
                    to="#basictab1"
                    data-bs-toggle="tab"
                  >
                    InvoGenie Report
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="#basictab2"
                    data-bs-toggle="tab"
                  >
                    <i className="la la-upload la-lg me-2"></i>
                    تحميل مستندات
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="#basictab3"
                    data-bs-toggle="tab"
                  >
                    More...
                  </Link>
                </li>

                {/* <li className="nav-item">
                <Link
                  className="nav-link"
                  data-bs-toggle="modal"
                  data-bs-target="#ai-agent"
                  // data-bs-toggle="tab"
                >
                  مساعد AI
                </Link>
              </li> */}
              </ul>
            </div>

            {/* {prompt && <AiGemelAgent prompt={prompt} />} */}
          </div>
          <div className="tab-content">
            <div className="tab-pane show active" id="basictab1">
              <OpenVatCalculator />

              {/* <AppliedJobsTable /> */}
            </div>
            <div className="tab-pane" id="basictab2">
              <div className="card">
                <div className="card-header border-bottom-0 mt-2">
                  <h2 className="text-primary card-title text-center pt-2">
                    فحص ملفات ضريبية
                  </h2>
                </div>
                <div className="card-body">
                  <FilesAi triggerUploadFromSearch={triggerChildFileUpload} />
                </div>
              </div>
            </div>
            <div className="tab-pane" id="basictab3">
              <div className="card">
                <div className="card-header">
                  <h1 className="text-primary  text-center p-4">
                    Wait For MAssAI 2027
                  </h1>
                </div>
              </div>
            </div>
          </div>

          {/* <DashboardWidget />
        <DashboardGraph />
        <OfferedJobs />
        <AppliedJobsTable /> */}
          <DeleteModal Name="Delete" />
        </div>
      </div>
    </div>
  );
}
